import COMBOS from './keyboardShortcutsCombos';

export default [
  {
    name: 'Run',
    combination: COMBOS.runAnnotator.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'New Entity, Dictionary, Concept, Intent',
    iconClass: '',
    combination: COMBOS.createNew.toUpperCase(),
  },
  {
    name: 'Save',
    combination: COMBOS.saveNew.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Spotlight Search',
    combination: COMBOS.spotlightSearch.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Closes test set',
    combination: COMBOS.closeTestSet.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Closes inspect',
    combination: COMBOS.closeInspect.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Move DOWN/UP in a list (Entities, Dictionaries, Concepts, Intents)',
    iconClass: 'icon-arrows-up-down',
    combination: '',
  },
  {
    name: 'Include / Exclude (Entities only)',
    combination: COMBOS.excludeLine.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Open inspect window',
    combination: COMBOS.openInspect.toUpperCase(),
    iconClass: '',
  },
  {
    name: 'Closes Add To dictionary Pop up',
    combination: COMBOS.closeAddToDictionary.toUpperCase(),
    iconClass: '',
  },
  {
    // editor shortcuts
    name: 'Go to line',
    combination: COMBOS.goToLine,
    iconClass: '',
  },
  {
    name: 'Move line up',
    combination: COMBOS.moveLineUp.windows,
    iconClass: '',
  },
  {
    name: 'Move line down',
    combination: COMBOS.moveLineDown.windows,
    iconClass: '',
  },
  {
    name: 'Search on file',
    combination: COMBOS.openEditorSearch,
    iconClass: '',
  },
  {
    name: 'Duplicate line',
    combination: COMBOS.duplicateLine,
    iconClass: '',
  },
  {
    name: 'Delete line',
    combination: COMBOS.editorDeleteLine.windows,
    iconClass: '',
  },
  {
    name: 'Bookmark line',
    combination: COMBOS.bookmarkLine,
    iconClass: '',
  },
  {
    name: 'Next bookmark',
    combination: COMBOS.nextBookmark,
    iconClass: '',
  },
  {
    name: 'Previous bookmark',
    combination: COMBOS.previousBookmark,
    iconClass: '',
  },
  {
    name: 'Comment line',
    combination: COMBOS.commentLine,
    iconClass: '',
  },
];
